<template>
    <div id="LocalPack">
        <router-view/>
    </div>
</template>


<script>


export default {
    name: 'Root',
    components: {},
    data: () => ({
        IS_PROD_MODE: process.env.NODE_ENV === 'production',
    }),
    computed: {
        branchesList() {
            return this.projectBranchesListDomain.query.response
        },
        sourcesList() {
            return this.projectSourcesListDomain.query.response
        },
    },
    methods: {
        setFont() {
            // let link = document.createElement('link')
            // link.rel = "stylesheet"
            // link.href = "https://fonts.googleapis.com/css?family=Roboto"
            // document.head.appendChild(link)
        },
        
        parseUrlGetParams() {
            this.$store.state.init.routeQuery = this.$route.query
            
            // router.afterEach((to, from) => {
            //     console.log('afterEach', from, to)
            // })
        },
    },
    created() {
        this.parseUrlGetParams()
    },
    async mounted() {
        this.setFont()
        
        if (this.$route.name === 'Root') {
            if (this.$store.getters.currentTab === 'keywords') {
                await this.$router.push({ name: 'KeywordList' })
            }
            else {
                await this.$router.push({ name: 'BranchList' })
            }
        }
        else if (this.$route.name === 'BranchList' || this.$route.name === 'RankByBranch') {
            await this.$store.dispatch('setCurrentTab', 'branches')
        }
        else if (this.$route.name === 'KeywordList' || this.$route.name === 'RankByKeyword') {
            await this.$store.dispatch('setCurrentTab', 'keywords')
        }
        
        await this.$store.dispatch('fetchDataForFilters')
    }
}
</script>

<style lang="less">
//@import "./node_modules/view-design/src/styles/custom";
//@import "./node_modules/view-design/src/styles/mixins/index";
//@import "./node_modules/view-design/src/styles/common/index";
//@import "./node_modules/view-design/src/styles/animation/index";

@c-active: #32a3f3;
@c-action: #4CAF50;

html, body {
    height: 100%;
}

body {
    margin: 0;
    background: #f7f7f7;
    box-sizing: border-box;
    font-family: Roboto, Tahoma, Arial, helvetica, sans-serif;
    line-height: 1.3;
}

#LocalPack {
    font-family: Roboto, Tahoma, Arial, helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    font-size: 10px;
    line-height: 1.6;

    display: flex;
    justify-content: stretch;
    height: 100%;
    
    &>div {
        width: 100%;
    }
    
    .page {
        display: block;
        width: 100%;
    }

    .sidebar {
        width: 250px;
        background: #616161;
    }

    .content {
        padding: 20px 40px;
        width: 1100px;
    }

    ///////////////////
    .pageHeader {
        .pageHeader__title {
            font-size: 2.2em;
            font-weight: 700;
        }

        .pageHeader__description {
            font-size: 1.4em;
            color: #888;
            margin-top: 0.6em;
        }
    }

    .pageTopBar {
        margin-top: 2.4em;
    }

    .pageMainSection {
        margin-top: 2em;
        //max-width: 1850px;
    }

    //////////////////////////


    .statsDateInfo {
        display: flex;
        flex-flow: column nowrap;

        .__showDate {
            font-size: 14px;
        }

        .__nextDate {
            font-size: 12px;
            color: #b3b3b3;
        }
    }

    //////////////////////////
    // =======================
    .buttonGroup {
        box-shadow: 0 0 3px #ccc;
        .button {
            border-radius: 0;
        }

        .button:first-of-type {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
        }

        .button:last-of-type {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
        }
    }

    .iconBtn {
        cursor: pointer;

        &.--active {
            color: @c-active;
        }
    }

    .sortBtn:extend(.iconBtn) {
        font-size: 0.8em;
        margin-left: 0.5em;

        &.--active {
            color: @c-active;
        }
    }

    .headerSourceIcon {
        width: 23px;
        height: 23px;
        position: relative;
        top: -2px;
        left: -4px;
    }

    // =======================
    //////////////////////////


    .xCard {
        display: flex;
        box-shadow: 0 0 4px #ccc;
        border-radius: 5px;
        background: #fff;
        font-size: 1.4em;
        align-items: stretch;

        &:nth-of-type(n+2) {
            margin-top: 10px;
        }

        .__title {
            display: inline-flex;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 1.4em;
            cursor: pointer;

            &:hover {
                color: @c-active;
            }
        }

        .__description {
            display: inline-flex;
            color: #777;
            margin-left: 2em;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        &.xCard--column {
            flex-flow: column;
        }

        .xCard__header {
            display: flex;
            border-bottom: 1px solid #ccc;
            padding: 20px 20px 12px 20px;

            & > div:nth-of-type(n+2) {
                margin-left: 2em;
            }

            .xCard__description {
                font-size: 0.8em;
                color: #777;
            }

            .xCard__title {
                font-size: 1.4em;
            }
        }

        .xCard__body {
            padding: 20px;
        }
    }

    .tableGroup {
        display: flex;
        justify-content: flex-start;
        font-size: 10px;

        .table:nth-of-type(n+2) {
            margin-left: -1px
        }
    }


    .positionChange {
        margin-left: 0.6em;
        width: 18px;
        display: inline-block;

        &__up {
            color: #569c56;
        }

        &__down {
            color: #ff6868;
        }

        &__value {
            vertical-align: super;
            font-size: 0.8em;
            color: #777;
        }
    }


    ////////////////////
    // Анимация роутинга
    .fade-enter-active,
    .fade-leave-active {
        transition-property: opacity;
        transition-duration: 0.3s;
    }

    .fade-enter-active {
        transition-delay: 0.3s;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }

    // Анимация роутинга
    ////////////////////
    
    
    .zPaginator .ivu-page {
        margin-top: 2em;
    }
    
    .localPack__sidebar {

    }

    .RankByKeywordPage, .RankByBranchPage, .KeywordListPage, .BranchListPage {
        .table.--zebraColumns {
            flex-shrink: 3;
            .tableCell {
                min-width: 160px;
            }
        }
    }
    
    .BranchListPage {
        .pageTopBar {
            grid-template-columns: 100%;
        }
        .pageMainSection__inner {
            grid-template-columns: 100%;
        }
    }
    
    .sidebarFilters {
        margin-top: 16px;
    }

    .ivu-tooltip-inner {
        font-size: 12px;
        max-width: none;
    }
    
    .a-button.a-button--link {
        text-decoration: underline;
        vertical-align: baseline;
        display: inline-flex;
    }
    .a-button.a-button--grey {
        color: #909090;
    }
    .a-button.a-button--action {
        color: @c-action;
    }
    
    .ivu-input {
        border-radius: 4px !important;
    }
}

// Монтируется прямо в body
.ivu-modal {
    width: 80% !important;
    max-width: 800px;
    top: 70px !important;
    margin-bottom: 300px !important;
    .ivu-modal-header {
        padding: 16px 32px 10px;
    }
    .ivu-modal-footer {
        padding: 16px 32px;
    }
    .ivu-modal-body {
        padding: 4px 32px 16px;
        .about-repometr {
            p:nth-of-type(n+2) {
                margin-top: 0.8em;
            }
            ul {
                margin: auto;
                padding-left: 16px;
                li {
                    margin: auto;
                    padding: 4px 0 4px 8px;
                }
            }
            img {
                max-width: 100%;
            }
            .promo-block {
                display: block;
                box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
                border-radius: 5px;
                background: #fff;
                padding: 30px;
                margin: 28px 0;
                background: linear-gradient(120deg, #f59633 11.93%, #d69bce 106.07%);
                font-size: 18px;
                color: #fff;
            }
            .info-block {
                display: block;
                box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
                border-radius: 5px;
                background: #fff;
                padding: 30px;
                margin: 20px 0;
                .info-block__title {
                    font-size: 16px;
                    font-weight: 700;
                }
                .info-block__body {
                    margin-top: 12px;
                }
                &.info-block--flat {
                    padding: 0;
                    box-shadow: none;
                }
                &.info-block--promo {
                    background: linear-gradient(120deg, #8c8288 51.93%, #3a2c35 106.07%);
                    color: #fff;
                }
            }
            
            form {
                display: flex;
                flex-flow: column nowrap;
                .form-field {
                    &:nth-of-type(n+2) {
                        margin-top: 16px;
                    }
                    .form-field__title {
                        margin-bottom: 6px;
                    }
                }
                .ivu-input {
                    //width: 400px;
                    border-radius: 4px !important;
                }
                .button {
                    font-size: inherit;
                }
            }
        }
    }
}

.button {
    outline: none;
    border: 1px solid #fff;
    border-radius: 3px;
    background: #fff;
    color: #888;
    padding: 5px 12px;
    cursor: pointer;
    font-size: 12px;

    &.--active {
        background: @c-active;
        border-color: @c-active;
        color: #fff;
    }

    &.button--system {
        background: #bfb5ab;
        border-color: #bfb5ab;
        color: #fff;

        i {
            margin-right: 0.7em;
        }
    }

    &.button--primary {
        background: #7bbd65;
        border-color: #7bbd65;
        color: #fff;
    }
}

</style>
